import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { ClipboardList } from 'lucide-react';
import { listOrders } from '../../api/orders';
import { PageHeader } from '../../components/ui/PageHeader';
import { Card } from '../../components/ui/Card';
import { Table, Thead, Th, Tr, Td } from '../../components/ui/Table';
import { StatusBadge, Badge } from '../../components/ui/Badge';
import { Spinner } from '../../components/ui/Spinner';
import { EmptyState } from '../../components/ui/EmptyState';

function money(lines: { priceSnapshot: string; quantity: number }[]) {
  const total = lines.reduce((sum, l) => sum + Number(l.priceSnapshot) * l.quantity, 0);
  return `£${total.toFixed(2)}`;
}

export function OrdersListPage() {
  const ordersQuery = useQuery({ queryKey: ['orders'], queryFn: listOrders });

  return (
    <div>
      <PageHeader title="Orders" description="Every order you've submitted, or that's relevant to you." />

      <Card>
        {ordersQuery.isLoading ? (
          <div className="py-14 text-center">
            <Spinner />
          </div>
        ) : !ordersQuery.data || ordersQuery.data.length === 0 ? (
          <EmptyState icon={ClipboardList} title="No orders yet" description="Orders you submit will show up here." />
        ) : (
          <Table>
            <Thead>
              <tr>
                <Th>Reference</Th>
                <Th>Status</Th>
                <Th>Charge type</Th>
                <Th>Total</Th>
                <Th>Submitted</Th>
              </tr>
            </Thead>
            <tbody>
              {ordersQuery.data.map((order) => (
                <Tr key={order.id} className="cursor-pointer">
                  <Td className="font-medium text-slate-900">
                    <Link to={`/orders/${order.id}`} className="hover:text-brand-700">
                      {order.reference}
                    </Link>
                  </Td>
                  <Td>
                    <StatusBadge status={order.status} kind="order" />
                  </Td>
                  <Td>
                    {order.chargeType ? (
                      <Badge tone="blue">{order.chargeType.replace('_', '-')}</Badge>
                    ) : (
                      <span className="text-slate-400">-</span>
                    )}
                  </Td>
                  <Td>{money(order.lines)}</Td>
                  <Td>{new Date(order.createdAt).toLocaleDateString()}</Td>
                </Tr>
              ))}
            </tbody>
          </Table>
        )}
      </Card>
    </div>
  );
}
